import axios from "@/hooks/axios/axios";
import type {
  DashboardStats,
  TopClientsResponse,
  TopClientsParams,
  RecentActivityResponse,
  RecentActivityParams,
  ExpiringSubscriptionsResponse,
  ExpiringSubscriptionsParams,
} from "../types/dashboard.types";

export const getDashboardStats = async (): Promise<DashboardStats> => {
  const { data } = await axios.get("/dashboard/stats");
  return data;
};

export const getTopClients = async (
  params: TopClientsParams = {},
): Promise<TopClientsResponse> => {
  const { limit = 6 } = params;
  const validatedLimit = Math.max(1, Math.min(20, limit));

  const { data } = await axios.get("/dashboard/top-clients", {
    params: { limit: validatedLimit },
  });
  return data;
};

export const getRecentActivity = async (
  params: RecentActivityParams = {},
): Promise<RecentActivityResponse> => {
  const { limit = 10 } = params;
  const validatedLimit = Math.max(1, Math.min(50, limit));

  const { data } = await axios.get("/dashboard/recent-activity", {
    params: { limit: validatedLimit },
  });
  return data;
};

export const getExpiringSubscriptions = async (
  params: ExpiringSubscriptionsParams = {},
): Promise<ExpiringSubscriptionsResponse> => {
  const { days_ahead = 12 } = params;
  const validatedDays = Math.max(1, Math.min(90, days_ahead));

  const { data } = await axios.get("/dashboard/expiring-subscriptions", {
    params: { days_ahead: validatedDays },
  });
  return data;
};
